import angular from "angular";

angular
    .module('app')
    .controller('MainController', ['Auth', '$uibModal', '$rootScope', '$http', function (Auth, $uibModal, $rootScope, $http) {

        let $ctrl = this;

        $ctrl.notificationsCount = null;

        $ctrl.$onInit = function () {
            $ctrl.user = Auth.user();
        };

        $ctrl.openLoginModal = function () {
            Auth.openLoginModal().then(
                function (user) {
                    $ctrl.user = user;
                    $rootScope.$emit('UserLoginFromHeader', {user});
                }
            );
        };

        $ctrl.openRegisterModal = function () {
            Auth.openRegisterModal().then(
                function (user) {
                    $ctrl.user = user;
                    $rootScope.$emit('UserLoginFromHeader', {user});
                }
            );
        };

        $ctrl.logout = function () {
            $http
                .post('/logout')
                .then(
                    function () {
                        window.location = '/';
                    },
                    function (error) {
                    }
                );
        };

        $rootScope.$on('UserLoginFromCoursePage', function (event, data) {
            $ctrl.user = data.user;
        });

        $rootScope.$on('ReduceCountNotifications', function (event, data) {
                $ctrl.notificationsCount -= data.count;
        });

    }]);
